import { Grid2, Paper } from "@mui/material";
import { Box } from "@mui/system";
import { Outlet } from "react-router";
import { AuthFooter } from "../pages/login/_components/authFooter.screen";
import { authScreenStyles } from "../_styles/authScreen.styles";

const backgroundImage = require('../_assets/images/Generic-Accountancy_Image.png');

export const AuthScreen = () => {
    return (
        <div id="app-screen" style={authScreenStyles.appScreen as React.CSSProperties}>

            <div style={authScreenStyles.main}>
                <Grid2 container sx={authScreenStyles.container}>

                    <Grid2 size={{ xs: 12, md: 5 }} sx={authScreenStyles.formContainer}>
                        <Paper elevation={0} sx={authScreenStyles.paper}>
                            <Outlet />
                        </Paper>
                    </Grid2>

                    {/* image with gradient */}
                    <Grid2 size={{ md: 7 }} sx={authScreenStyles.bgImageContainer}>
                        <Box sx={authScreenStyles.bgImage(backgroundImage)} />
                        <Box sx={authScreenStyles.overlay} />
                    </Grid2>
                </Grid2>
            </div>
            {/* 
            <Box component="footer" sx={authScreenStyles.footer}>
                <AuthFooter />
            </Box> */}
        </div>

    );
}